<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <v-form ref="data_list" @submit.prevent="purchase_save">

        <v-card elevation="6" class="mb-12" v-for="(count, index) in product_list" :key="index">
          <div class="pa-3">
            <div class="grid_half">
              <div class="grid_sidebyside">
                <!--              <div class="ma-6">-->
                <!--                <div class="ml-1">เลขที่ใบสั่งซื้อ</div>-->
                <!--              </div>-->
                <!--              <div class="mt-3 mr-1">-->
                <!--                <v-text-field class="input_width" hide-details="auto" v-model="confirm_list.po_id" disabled></v-text-field>-->
                <!--              </div>-->
                <div class="ma-6">
                  <div class="ml-1">บริษัท</div>
                </div>
                <div class="mt-6 mr-1 detail_style">
                  {{ count.supplier_name }}
                </div>
                <div class="ma-6">
                  <div class="ml-1">แผนก</div>
                </div>
                <div class="mt-6 mr-1 detail_style">
                  {{ count.sup_department }}
                </div>
                <div class="ma-6">
                  <div class="ml-1">การสั่งซื้อ</div>
                </div>
                <div class="mt-6 mr-1 detail_style" v-if="count.credit_status == 0">
                  เงินสด
                </div>
                <div class="mt-6 mr-1 detail_style" v-if="count.credit_status == 1">
                  เครดิต
                </div>
              </div>
              <div>
                <div class="ma-6">
                  <div class="ml-1">ภาษีมูลค่าเพิ่ม </div>
                </div>
                <div class="mt-3 mr-1">
                  <v-radio-group v-model="count.type_vat" mandatory>
                    <div class="d-flex justify-space-around">
                      <div class="d-flex ml-5">
                        <div>
                          <v-radio color="#86bc3a" :value="0"></v-radio>
                        </div>
                        <div>ภาษีรวมใน</div>
                      </div>
                      <div class="d-flex">
                        <div>
                          <v-radio color="#86bc3a" :value="1"></v-radio>
                        </div>
                        <div>ภาษีแยกนอก</div>
                      </div>
                    </div>
                    <div class="d-flex justify-space-around mt-6">
                      <div class="d-flex" style="margin-left: 3px">
                        <div>
                          <v-radio color="#86bc3a" value="2"></v-radio>
                        </div>
                        <div>ไม่กระทบภาษี</div>
                      </div>
                      <div class="d-flex ml-n12">
                        <div>
                          <v-radio color="#86bc3a" value="3"></v-radio>
                        </div>
                        <div>ภาษีเป็น 0</div>
                      </div>
                    </div>
                  </v-radio-group>
                </div>
              </div>
            </div><br>
            <v-divider></v-divider>
            <div class="pa-4">
              <span style="font-size: 24px">รายการสินค้า</span>
            </div>
            <div class="pa-2">
              <v-card-title>
                <v-text-field v-model="count.search" color="#86bc3a" append-icon="mdi-magnify" label="ค้นหา" single-line
                  hide-details></v-text-field>
              </v-card-title>
              <v-data-table :headers="Headers" :items="count.lists"  :items-per-page="-1" :key="index" :search="count.search"
                mobile-breakpoint="0" hide-default-footer>
                <template v-slot:item="dataDetail">
                  <tr>
                    <td>{{ dataDetail.index + 1 }}</td>
                    <td>{{ dataDetail.item.product_code }}</td>
                    <td>{{ dataDetail.item.name }}</td>
                    <td class="pa-3">
                      <v-btn
                        small
                        height="42"
                        @click="getHistory(dataDetail.item)"
                        class="grad-success-bg white--text mb-1"
                      >
                        <v-icon>mdi-magnify</v-icon>
                      </v-btn>
                    </td>
                    <td>
                      <v-select color="#86bc3a" class="input_width" :items="dataDetail.item.product_lists"
                        item-text="unit_name" item-value="unit_id" :rules="[v => !!v || 'กรุณากรอกหน่วยนับ']"
                        v-model="dataDetail.item.units" label="หน่วยนับ" hide-details="auto" outlined></v-select>
                    </td>
                    <td>
                      <div class="ma-3 ml-1 ">
                        <v-text-field color="#86bc3a" type="number" min="0" @keypress="isOnlyNumber($event)"
                          :rules="[v => !!v && v > 0 && v > '0' || 'กรุณากรอกจำนวนและต้องมากกว่า 0']" label="จำนวน"
                          hide-details="auto" v-model="dataDetail.item.amount" outlined></v-text-field>
                      </div>
                    </td>
                    <td>
                      <div class="ma-3 ml-1">
                        <v-text-field color="#86bc3a" type="number" min="0"
                          @keypress="isCurrency($event, dataDetail.item.price)" :rules="[v => (v === 0 || v === '0' || (v !== null && v !== undefined && v !== '')) || 'กรุณากรอกราคา']"
                          label="ราคา" hide-details="auto" v-model="dataDetail.item.price" outlined></v-text-field>
                      </div>
                    </td>
                    <td>
                      <div class="ma-3 ml-1">
                        <v-text-field color="#86bc3a" type="number" min="0"
                          @keypress="isCurrency($event, dataDetail.item.discount_unit)" label="ส่วนลด(บาท)"
                          hide-details="auto" v-model="dataDetail.item.discount_unit" outlined></v-text-field>
                      </div>
                    </td>
                    <td>
                      <div class="ma-3 ml-1">
                        <v-text-field color="#86bc3a" type="number" min="0"
                          @keypress="isCurrency($event, dataDetail.item.discount_percent)" label="ส่วนลด(%)"
                          hide-details="auto" v-model="dataDetail.item.discount_percent" outlined></v-text-field>
                      </div>
                    </td>
                    <td>{{ format_price(dataDetail.item.total = (((dataDetail.item.price) - ((dataDetail.item.price *
                      dataDetail.item.discount_percent) / 100)) * dataDetail.item.amount) - dataDetail.item.discount_unit)
                    }}</td>
                  </tr>
                </template>
                <template v-slot:body.append>
                  <tr class="total_color">
                    <td colspan="6" class="border_col"></td>
                    <td colspan="1" class="pa-2 border_col">
                      <div class="ma-4">
                        <div class="text_total">ยอดรวมสินค้า</div>
                      </div>
                    </td>
                    <td colspan="2" class="pa-2 border_col">
                      <div class="ma-4">
                        <div class="text-center">{{ count.subTotal = sub_total(count.supplier, count.credit_status) }}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr class="discount_color">
                    <td colspan="6" class="border_col"></td>
                    <td colspan="1" class="pa-2 border_col">
                      <div class=" ma-4">
                        <div class="text_total">ส่วนลด(%)</div>
                      </div>
                    </td>
                    <td colspan="2" class="pa-2 border_col">
                      <div class="ma-4">
                        <div>
                          <v-text-field color="#86bc3a" label="ส่วนลด(%)" append-icon="mdi-percent-outline" type="number"
                            @keypress="isCurrency($event, count.percent)" hide-details="auto" min="0" max="100"
                            v-model="count.percent" outlined></v-text-field>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr class="discount_color">
                    <td colspan="6" class="border_col"></td>
                    <td colspan="1" class="pa-2 border_col">
                      <div class=" ma-4">
                        <div class="text_total">ส่วนลด(บาท)</div>
                      </div>
                    </td>
                    <td colspan="2" class="pa-2 border_col">
                      <div class="ma-4">
                        <div>
                          <v-text-field color="#86bc3a" label="ส่วนลด(บาท)" append-icon="mdi-cash-100" type="number"
                            @keypress="isCurrency($event, count.per_unit)" hide-details="auto" min="0" max="100"
                            v-model="count.per_unit" outlined></v-text-field>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr class="discount_color">
                    <td colspan="6" class="border_col"></td>
                    <td colspan="1" class="border_col">
                      <div class="ml-2 mb-7 text_total">มูลค่าสินค่า</div>
                      <div class="ml-2 pt-1 text_total">ภาษีมูลค่าเพิ่ม 7.00%</div>
                    </td>
                    <td colspan="2" class="pa-2 border_col">
                      <div class="ma-4 text-center">{{ count.no_vat = no_vat(count.supplier, count.credit_status) }}</div>
                      <v-divider />
                      <div class="ma-4 text-center">{{ count.include_vat = cal_vat(count.supplier, count.credit_status) }}
                      </div>
                    </td>
                  </tr>
                  <tr class="total_color">
                    <td colspan="6" class="border_col"></td>
                    <td colspan="1" class="pa-2 border_col">
                      <div class="ma-4">
                        <div class="text_total">รวมเงินทั้งสิ้น</div>
                      </div>
                    </td>
                    <td colspan="2" class="pa-2 border_col">
                      <div class="ma-4">
                        <div class="text-center">{{ count.total_grand = totalSum(count.supplier, count.credit_status) }}
                        </div>
                      </div>
                    </td>
                  </tr>
                  <v-divider />
                </template>
              </v-data-table>
              <div class="pa-4">
                <div class="mb-4">
                  หมายเหตุ
                </div>
                <v-textarea color="#86bc3a" label="กรุณากรอกหมายเหตุ" v-model="count.note" outlined></v-textarea>
              </div>
            </div>
          </div>
        </v-card>
        <div class="mt-2 pa-4 text-right">
          <v-btn x-large type="submit" class="grad-success-bg white--text btn_mobile"
            style="font-size: 18px">บันทึกรายการใบสั่งซื้อ</v-btn>
        </div>
      </v-form>

       <v-dialog v-model="product_history" max-width="1000">
        <v-card>
          <v-card-title>ประวัติการสั่งซื้อสินค้า</v-card-title>
          <v-card-text>
            <v-data-table :headers="history_headers" :items="history_list" class="elevation-1"> 
              <template v-slot:item="dataDetails">
                <tr>
                  <td>{{ dataDetails.item.receipt_date }}</td>
                  <td>{{ dataDetails.item.supplier_name }}</td>
                  <td>{{ dataDetails.item.quantity }}</td>
                  <td>{{ dataDetails.item.unit_name }}</td>
                  <td>{{ dataDetails.item.price }}</td>
                  <td>{{ dataDetails.item.cost }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="grad-warning-bg white--text" @click="product_history = false">ปิด</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular indeterminate size="70" width="7" color="#86bc3a"></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import { HTTP } from "@/axios";
import { diffDateEN, formatPrice, onlyForCurrency, onlyForNumber } from "@/js/handler";
import Swal from "sweetalert2";

export default {
  name: "ConfirmAdd_Purchase",
  data() {
    return {
      loading_page: false,
      overlay: false,
      Headers: [
        {
          text: 'ลำดับ',
          value: 'id',
          fixed: true,
          width: '100px',
        },
        {
          text: 'รหัสสินค้า',
          value: 'code',
          fixed: true,
          width: '140px',
        },
        {
          text: 'ชื่อสินค้า',
          value: 'name',
          fixed: true,
          width: '200px',
        },
        {
          text: 'ประวัติ',
          value: '',
          fixed: true,
          width: '100px',
        },
        {
          text: 'หน่วยนับ',
          value: 'unit',
          sortable: false,
          fixed: true,
          width: '150px',
        },
        {
          text: 'จำนวน',
          value: 'count',
          fixed: true,
          width: '170px',
        },
        {
          text: 'ราคา',
          value: 'price',
          fixed: true,
          width: '170px',
        },
        {
          text: 'ส่วนลด(บาท)',
          value: 'discount_unit',
          fixed: true,
          width: '170px',
        },
        {
          text: 'ส่วนลด(%)',
          value: 'discount_percent',
          fixed: true,
          width: '170px',
        },
        {
          text: 'รวม',
          value: 'total',
          fixed: true,
          width: '120px',
        },
      ],
      unitType: [
        { id: 1, name: 'กล่อง' },
        { id: 2, name: 'แพ็ค' },
        { id: 3, name: 'แผง' },
        { id: 4, name: 'หลอด' },
      ],
      product_list: [],
      supplier_get: [],
      value: [],
      confirm_list: {
        po_id: null,
        supplier_show: null,
      },
      product_history: false,
      history_list: [],
      selected_product: null,
      history_headers: [
        { text: 'วันที่', value: 'receipt_date' },
        { text: 'บริษัท', value: 'supplier_name' },
        { text: 'จำนวน', value: 'quantity' },
        { text: 'หน่วย', value: 'unit_name' },
        { text: 'ราคา', value: 'price' },
        { text: 'ต้นทุน', value: 'cost' },
      ],
    }
  },
  methods: {
    isOnlyNumber: function (evt) {
      return onlyForNumber(evt)
    },
    isCurrency: function (evt, number) {
      return onlyForCurrency(evt, number)
    },
    format_price: function (value) {
      return formatPrice(value)
    },
    diffEN: function (value) {
      return diffDateEN(value)
    },
    getHistory(product) {
      this.selected_product = product;
      this.product_history = true;
      HTTP.post('/purchaseorders/gethistoryimport', {
        product_id: product.product_id
      }).then((res) => {
        if (res.data.success) {
          this.history_list = res.data.object;
          console.log(this.history_list);
          
        }
      });
    },
    get_data() {
      this.product_list = [];
      // console.log(this.$store.state.purchase_list);
      const uniqueSupplier = [... new Set(this.$store.state.purchase_list.map(data => data.supplier))]
      
    

      uniqueSupplier.forEach((detail) => {
        let supplierDataName = this.$store.state.purchase_list.find((detail_filter) => {
          return detail_filter.supplier == detail
        })
        let department = supplierDataName.product_suppliers.find((data) => data.sup_id === supplierDataName.supplier)
       
        //ไม่เครดิต
        let supplierDataNotCredit = this.$store.state.purchase_list.filter((data) => { return data.status_credit != 1 && data.supplier == detail })
        
        if (supplierDataNotCredit.length > 0) {
          this.product_list.push({
            supplier: detail,
            supplier_name: supplierDataName.supplier_name,
            sup_department: department.sup_department,
            credit_status: 0,
            lists: supplierDataNotCredit,
            subTotal: 0,
            type_vat: 1,
            percent: 0,
            per_unit: 0,
            no_vat: 0,
            include_vat: 0,
            total_grand: 0,
            note: null,
            search: null,
          })
        }
        
        //เครดิต
        let supplierDataCredit = this.$store.state.purchase_list.filter((data) => { return data.status_credit == 1 && data.supplier == detail })
        
        if (supplierDataCredit.length > 0) {
          this.product_list.push({
            supplier: detail,
            supplier_name: supplierDataName.supplier_name,
            sup_department: department.sup_department,
            credit_status: 1,
            lists: supplierDataCredit,
            subTotal: 0,
            type_vat: 1,
            percent: 0,
            per_unit: 0,
            no_vat: 0,
            include_vat: 0,
            total_grand: 0,
            note: null,
            search: null,
          })
        }
      })
      console.log(this.product_list)

    },
    genIdCode() {
      HTTP.post('/purchaseorders/lastpocode')
        .then((res) => {
          this.confirm_list.po_id = res.data
        })
    },
    purchase_save() {
      let dateEN_format = this.diffEN(this.$store.state.date)
      if (this.$refs.data_list.validate()) {
        this.overlay = true
        HTTP.post('/purchaseorders/create', {
          purchase_date: dateEN_format,
          product_lists: this.product_list
        }).then((res) => {
          if (res.data.success === true) {
            this.overlay = false
            // ลบข้อมูล draft จาก localStorage เมื่อบันทึกสำเร็จ
            try {
              localStorage.removeItem('purchase_order_draft');
            } catch (error) {
              console.error('Error clearing localStorage:', error);
            }
            Swal.fire('บันทึกข้อมูลเรียบร้อย', '', 'success')
              .then(() => {
                this.$router.push('/purchase');
              });
          }
        })
      }
      else {
        Swal.fire({
          text: 'กรุณาตรวจสอบข้อมูล !',
          icon: 'error',
          showDenyButton: false,
          showCancelButton: false,
          confirmButtonText: `ตกลง`,
          denyButtonText: `ยกเลิก`,
        })
      }
    },
    sub_total(value, status) {
      if (status != 1) {
        let set = this.product_list.find((data) => {
          return data.supplier == value && data.credit_status != 1
        })
        const result = set.lists.reduce((sum, number) => {
          return sum + number.total
        }, 0)
        return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      else {
        let set = this.product_list.find((data) => {
          return data.supplier == value && data.credit_status == 1
        })
        const result = set.lists.reduce((sum, number) => {
          return sum + number.total
        }, 0)
        return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
    no_vat(value, status) {
      // if (status != 1) {
      //   let set = this.product_list.find((data) => {
      //     return data.supplier == value && data.credit_status != 1
      //   })
      //   const result = set.lists.reduce((sum, number) => {
      //     if (set.type_vat == '0') {
      //       let total_all = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.amount) - number.discount_unit;
      //       let dis_percent = ((total_all * set.percent) / 100);
      //       let total_final = total_all - dis_percent;
      //       let total_grand = total_final - set.per_unit;
      //       let in_vat = ((total_all * 7)/107);
      //       let total = total_grand - in_vat
      //       if (total < 0) {
      //         return sum + 0;
      //       }
      //       else {
      //         return sum + total;
      //       }
      //     }
      //     else if(set.type_vat == '1'){
      //       let total_all = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.amount) - number.discount_unit;
      //       let dis_percent = ((total_all * set.percent) / 100);
      //       let total_final = total_all - dis_percent;
      //       let total_grand = total_final - set.per_unit;
      //       if (total_grand < 0) {
      //         return sum + 0;
      //       }
      //       else {
      //         return sum + total_grand;
      //       }
      //     }
      //     else if(set.type_vat == '2'){
      //       let total_all = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.amount) - number.discount_unit;
      //       let dis_percent = ((total_all * set.percent) / 100);
      //       let total_final = total_all - dis_percent;
      //       let total_grand = total_final - set.per_unit;
      //       if (total_grand < 0) {
      //         return sum + 0;
      //       }
      //       else {
      //         return sum + total_grand;
      //       }
      //     }
      //     else if(set.type_vat == '3'){
      //       let total_all = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.amount) - number.discount_unit;
      //       let dis_percent = ((total_all * set.percent) / 100);
      //       let total_final = total_all - dis_percent;
      //       let total_grand = total_final - set.per_unit;
      //       if (total_grand < 0) {
      //         return sum + 0;
      //       }
      //       else {
      //         return sum + total_grand;
      //       }
      //     }
      //   }, 0)
      //   return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      // }
      // else {
      //   let set = this.product_list.find((data) => {
      //     return data.supplier == value && data.credit_status == 1
      //   })
      //   const result = set.lists.reduce((sum, number) => {
      //     if (set.type_vat == '0') {
      //       let total_all = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.amount) - number.discount_unit;
      //       let dis_percent = ((total_all * set.percent) / 100);
      //       let total_final = total_all - dis_percent;
      //       let total_grand = total_final - set.per_unit;
      //       let in_vat = ((total_all * 7)/107);
      //       let total = total_grand - in_vat;
      //       if (total < 0) {
      //         return sum + 0;
      //       }
      //       else {
      //         return sum + total;
      //       }
      //     }
      //     else if(set.type_vat == '1'){
      //       let total_all = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.amount) - number.discount_unit;
      //       let dis_percent = ((total_all * set.percent) / 100);
      //       let total_final = total_all - dis_percent;
      //       let total_grand = total_final - set.per_unit;
      //       if (total_grand < 0) {
      //         return sum + 0;
      //       }
      //       else {
      //         return sum + total_grand;
      //       }
      //     }
      //     else if(set.type_vat == '2'){
      //       let total_all = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.amount) - number.discount_unit;
      //       let dis_percent = ((total_all * set.percent) / 100);
      //       let total_final = total_all - dis_percent;
      //       let total_grand = total_final - set.per_unit;
      //       if (total_grand < 0) {
      //         return sum + 0;
      //       }
      //       else {
      //         return sum + total_grand;
      //       }
      //     }
      //     else if(set.type_vat == '3'){
      //       let total_all = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.amount) - number.discount_unit;
      //       let dis_percent = ((total_all * set.percent) / 100);
      //       let total_final = total_all - dis_percent;
      //       let total_grand = total_final - set.per_unit;
      //       if (total_grand < 0) {
      //         return sum + 0;
      //       }
      //       else {
      //         return sum + total_grand;
      //       }
      //     }
      //   }, 0)
      //   return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      // }

      if (status != 1) {
        let set = this.product_list.find((data) => {
          return data.supplier == value && data.credit_status != 1
        })
        const subTotal = set.lists.reduce((sum, number) => {
          return sum + number.total;
        }, 0)

        let percent = (parseFloat(subTotal) * set.percent) / 100;
        let total_percent = parseFloat(subTotal) - percent;
        let total_discount = total_percent - set.per_unit;

        if (set.type_vat == '0') {
          let before_vat = total_discount * (100 / 107);
          return before_vat.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else {
          return total_discount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
      }
      else {
        let set = this.product_list.find((data) => {
          return data.supplier == value && data.credit_status == 1
        })
        const subTotal = set.lists.reduce((sum, number) => {
          return sum + number.total;
        }, 0)

        let percent = (parseFloat(subTotal) * set.percent) / 100;
        let total_percent = parseFloat(subTotal) - percent;
        let total_discount = total_percent - set.per_unit;

        if (set.type_vat == '0') {
          let before_vat = total_discount * (100 / 107);
          return before_vat.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else {
          return total_discount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
      }
    },
    cal_vat(value, status) {
      // if (status != 1) {
      //   const set = this.product_list.find((data) => {
      //     return data.supplier == value && data.credit_status != 1
      //   })
      //   const result = set.lists.reduce((sum, number) => {
      //     if (set.type_vat == '0') {
      //       let total_all = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.amount) - number.discount_unit;
      //       let calculate = ((total_all * 7)/107);
      //       return sum + (calculate);
      //     }
      //     else if(set.type_vat == '1') {
      //       let total_all = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.amount) - number.discount_unit;
      //       let calculate = (total_all * (7 / 100));
      //       return sum + (calculate);
      //     }
      //     else if(set.type_vat == '2') {
      //       let calculate = 0;
      //       return sum + (calculate);
      //     }
      //     else if(set.type_vat == '3') {
      //       let calculate = 0;
      //       return sum + (calculate);
      //     }
      //   }, 0)
      //   return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      // }
      // else {
      //   const set = this.product_list.find((data) => {
      //     return data.supplier == value && data.credit_status == 1
      //   })
      //   const result = set.lists.reduce((sum, number) => {
      //     if (set.type_vat == '0') {
      //       let total_all = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.amount) - number.discount_unit;
      //       let calculate = ((total_all * 7)/107);
      //       return sum + (calculate);
      //     }
      //     else if(set.type_vat == '1') {
      //       let total_all = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.amount) - number.discount_unit;
      //       let calculate = (total_all * (7 / 100));
      //       return sum + (calculate);
      //     }
      //     else if(set.type_vat == '2') {
      //       let calculate = 0;
      //       return sum + (calculate);
      //     }
      //     else if(set.type_vat == '3') {
      //       let calculate = 0;
      //       return sum + (calculate);
      //     }
      //   }, 0)
      //   return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      // }

      if (status != 1) {
        let set = this.product_list.find((data) => {
          return data.supplier == value && data.credit_status != 1
        })
        const subTotal = set.lists.reduce((sum, number) => {
          return sum + number.total;
        }, 0)

        let percent = (parseFloat(subTotal) * set.percent) / 100;
        let total_percent = parseFloat(subTotal) - percent;
        let total_discount = total_percent - set.per_unit;

        if (set.type_vat == '0') {
          let before_vat = total_discount * (7 / 107);
          return before_vat.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else if (set.type_vat == '1') {
          let before_vat = total_discount * (7 / 100);
          return before_vat.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else {
          let zero = 0
          return zero.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
      }
      else {
        let set = this.product_list.find((data) => {
          return data.supplier == value && data.credit_status == 1
        })
        const subTotal = set.lists.reduce((sum, number) => {
          return sum + number.total;
        }, 0)

        let percent = (parseFloat(subTotal) * set.percent) / 100;
        let total_percent = parseFloat(subTotal) - percent;
        let total_discount = total_percent - set.per_unit;

        if (set.type_vat == '0') {
          let before_vat = total_discount * (7 / 107);
          return before_vat.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else if (set.type_vat == '1') {
          let before_vat = total_discount * (7 / 100);
          return before_vat.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else {
          let zero = 0
          return zero.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
      }
    },
    totalSum(value, status) {
      // if (status != 1) {
      //   const set = this.product_list.find((data) => {
      //     return data.supplier == value && data.credit_status != 1
      //   })
      //   const result = set.lists.reduce((sum, number) => {
      //     if (set.type_vat == '0'){
      //       let total_all = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.amount) - number.discount_unit;
      //       let dis_percent = ((total_all * set.percent) / 100);
      //       let total_final = total_all - dis_percent;
      //       let total_grand = total_final - set.per_unit;
      //       if (total_grand < 0) {
      //         return sum + 0;
      //       }
      //       else {
      //         return sum + total_grand;
      //       }
      //     }
      //     else if (set.type_vat == '1'){
      //       let total = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.amount) - number.discount_unit;
      //       let dis_percent = ((total * set.percent) / 100);
      //       let total_final = total - dis_percent;
      //       let total_grand = total_final - set.per_unit;
      //       let ex_vat = ((total) * (7/100));
      //       let total_all = total_grand + ex_vat;
      //       if (total_all < 0) {
      //         return sum + 0;
      //       }
      //       else {
      //         return sum + (total_all);
      //       }
      //     }
      //     else if (set.type_vat == '2'){
      //       let total = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.amount) - number.discount_unit;
      //       let dis_percent = ((total * set.percent) / 100);
      //       let total_final = total - dis_percent;
      //       let total_grand = total_final - set.per_unit;
      //       if (total_grand < 0) {
      //         return sum + 0;
      //       }
      //       else {
      //         return sum + (total_grand);
      //       }
      //     }
      //     else if (set.type_vat == '3'){
      //       let total = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.amount) - number.discount_unit;
      //       let dis_percent = ((total * set.percent) / 100);
      //       let total_final = total - dis_percent;
      //       let total_grand = total_final - set.per_unit;
      //       if (total_grand < 0) {
      //         return sum + 0;
      //       }
      //       else {
      //         return sum + (total_grand);
      //       }
      //     }
      //   }, 0)
      //   return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      // }
      // else {
      //   const set = this.product_list.find((data) => {
      //     return data.supplier == value && data.credit_status == 1
      //   })
      //   const result = set.lists.reduce((sum, number) => {
      //     if (set.type_vat == '0'){
      //       let total_all = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.amount) - number.discount_unit;
      //       let dis_percent = ((total_all * set.percent) / 100);
      //       let total_final = total_all - dis_percent;
      //       let total_grand = total_final - set.per_unit;
      //       if (total_grand < 0) {
      //         return sum + 0;
      //       }
      //       else {
      //         return sum + total_grand;
      //       }
      //     }
      //     else if (set.type_vat == '1'){
      //       let total = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.amount) - number.discount_unit;
      //       let dis_percent = ((total * set.percent) / 100);
      //       let total_final = total - dis_percent;
      //       let total_grand = total_final - set.per_unit;
      //       let ex_vat = ((total * 7)/100);
      //       let total_all = total_grand + ex_vat;
      //       if (total_all < 0) {
      //         return sum + 0;
      //       }
      //       else {
      //         return sum + (total_all);
      //       }
      //     }
      //     else if (set.type_vat == '2'){
      //       let total = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.amount) - number.discount_unit;
      //       let dis_percent = ((total * set.percent) / 100);
      //       let total_final = total - dis_percent;
      //       let total_grand = total_final - set.per_unit;
      //       if (total_grand < 0) {
      //         return sum + 0;
      //       }
      //       else {
      //         return sum + (total_grand);
      //       }
      //     }
      //     else if (set.type_vat == '3'){
      //       let total = (( (number.price) - ((number.price * number.discount_percent) / 100)) * number.amount) - number.discount_unit;
      //       let dis_percent = ((total * set.percent) / 100);
      //       let total_final = total - dis_percent;
      //       let total_grand = total_final - set.per_unit;
      //       if (total_grand < 0) {
      //         return sum + 0;
      //       }
      //       else {
      //         return sum + (total_grand);
      //       }
      //     }
      //   }, 0)
      //   return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      //  }
      let before_vat = 0;
      let total_result = 0;
      if (status != 1) {
        let set = this.product_list.find((data) => {
          return data.supplier == value && data.credit_status != 1
        })
        const subTotal = set.lists.reduce((sum, number) => {
          return sum + number.total;
        }, 0)

        let percent = (parseFloat(subTotal) * set.percent) / 100;
        let total_percent = parseFloat(subTotal) - percent;
        let total_discount = total_percent - set.per_unit;

        if (set.type_vat == '1') {
          before_vat = total_discount * (7 / 100);
          total_result = total_discount + before_vat;
        } else {
          total_result = total_percent - set.per_unit;
        }

        return total_result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      else {
        let set = this.product_list.find((data) => {
          return data.supplier == value && data.credit_status == 1
        })
        const subTotal = set.lists.reduce((sum, number) => {
          return sum + number.total;
        }, 0)

        let percent = (parseFloat(subTotal) * set.percent) / 100;
        let total_percent = parseFloat(subTotal) - percent;
        let total_discount = total_percent - set.per_unit;

        if (set.type_vat == '1') {
          before_vat = total_discount * (7 / 100);
          total_result = total_discount + before_vat;
        } else {
          total_result = total_percent - set.per_unit;
        }

        return total_result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    },
  },
  mounted() {
    this.get_data();
    this.genIdCode();
  }
}
</script>

<style scoped>
.text_total {
  font-size: 14px;
}

.border_col {
  border-left: #f1f1f1 solid 2px;
  border-right: #f1f1f1 solid 2px;
}

.discount_input>>>input {
  text-align: end;
}

.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_sidebyside {
  display: grid;
  grid-template-columns: 30% 70%;
}

.input_width {
  width: 100%;
}

.discount_color {
  background-color: rgb(225 248 251);
}

.total_color {
  background-color: #e1ffb8;
}

@media only screen and (max-width: 1100px) {
  .grid_sidebyside {
    display: grid;
    grid-template-columns: 40% 60%;
  }
}

@media only screen and (max-width: 650px) {
  .detail_style {
    padding-left: 60px;
    margin-top: -5px !important;
  }

  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }

  .grid_sidebyside {
    display: grid;
    grid-template-columns: 100%;
  }

  .btn_mobile {
    width: 100%;
  }
}
</style>
